import type { Transition } from "framer-motion";

export const logoLayoutTransition: Transition = {
  layout: { type: "spring", stiffness: 100, damping: 18 },
};
